import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
	vendors: [{
		name:
			items: [{
				billingCode: str,
				deliveryLocationId: int,
				isOutOfStock: bool,
				itemName: str,
				itemNumber: str,
				notes: str,
				pricePerItem: int,
				quantity: int,
				url: str,
			}],
		}],
	urgency: int,
*/
const f = () => {
	return new Promise(resolve => {
		setTimeout(() => {
			resolve(100);
		}, 5000);
	});
};
async function handlePostAddOrder(requestorContactNumber, vendors, urgency, fetch, reasoning) {
	console.log('handlePostAddOrder', requestorContactNumber, vendors, urgency)
	const body = {
		requestorContactNumber: requestorContactNumber, 
		vendors: vendors,
		urgency: urgency,
		UrgencyJustification: reasoning || "",
	}

	//const response = null;
	const response = await fetch.post(`${apiBaseURL}/api/orders`, body);
	const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
	
	console.log('handlePostAddOrder body', body);
	console.log('handlePostAddOrder response', response);

	return {
		response,
		isDataGood
	};
}
export default handlePostAddOrder;